import { closest } from 'color-diff';
import { defineStore } from 'pinia';
import { useApi } from '@lib/api';
import { useGlobalStore } from '@/store/global-store-base';
import type { ColorDto } from '@/ApiClient';

export const useColorGroups = defineStore('color-groups', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.colorGroup_GetColorGroups,
    dto: 'ColorGroupDto',
    create: api.colorGroup_CreateColorGroup,
    update: api.colorGroup_UpdateColorGroup,
    delete: api.colorGroup_DeleteColorGroup,
    usage: api.colorGroup_CountUsages,
    signalR: 'ColorGroupUpdate',
  });

  const { loaded } = globalStoreBase;
  function findClosest(color: Pick<ColorDto, 'r' | 'g' | 'b'>) {
    return closest(color, loaded.value);
  }

  return {
    ...globalStoreBase,
    findClosest,
  };
});
